export default __webpack_public_path__ + "static/media/TURMALINA ROSA.525e0ca3.jpg";